<template>
    <div class="w-full bg-gray-200">
        <edit-report-page
            v-if="report && Object.keys(report).length"
            :report="report"
            :reportId="reportId"
            @on-cancel="onCancel"
            @on-reload-data-reports-list="onReloadDataReportsList"
            @update-report-item="updateReportItem"
            @reload-report-list="reloadReportList"
        />
    </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get"

import { reportApi } from "../services/reportService"
import { REPORT_ITEM_STATUS_ID_DISABLED, REPORT_TRIGGER_STATUS_ID_DISABLED } from '@/enum/reportStatuses'
import { setTimezoneData } from '@/enum/reportStaticData'

export default {
    name: "report-edit",
    components: {
        EditReportPage: () => import('@/modules/reports/components/edit-report/EditReportPage.vue')
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        reportId: {
            type: [Number, String],
            default: ''
        }
    },
    data() {
        return {
            report: {}
        }
    },
    methods: {
        onCancel() {
            this.$emit('on-close-create-report-tab')
        },
        onReloadDataReportsList () {
            this.$emit('on-reload-data-reports-list')
        },
        reloadReportList () {
            this.$emit('reload-report-list')
        },
        updateReportItem (data) {
            this.$emit('update-report-item', data)
        }
    },
    async mounted() {
        const updateReportData = () => {
            if (this.report.ReportItemList.length) {
                this.report.ReportItemList = this.report.ReportItemList.filter(el => el.ReportItemStatusID !== REPORT_ITEM_STATUS_ID_DISABLED)
            }
            if (this.report.ReportTriggerList.length) {
                this.report.ReportTriggerList = this.report.ReportTriggerList.filter(el => el.ReportTriggerStatusID !== REPORT_TRIGGER_STATUS_ID_DISABLED)
            }
        }
        if (this.data) {
            this.report = cloneDeep(this.data)
            updateReportData()
        } else {
            const data = await reportApi.info(this.reportId)
            if (!('timezone' in data)) {
                data.ReportConf = setTimezoneData()
            }
            this.report = cloneDeep(data)
            updateReportData()

            const reportName = get(data, 'ReportName', '')
            this.$emit('update-title', this.reportId, reportName)
        }
    }
}
</script>

<style lang="scss" scoped>
.report-edit {
    &-title {
        @apply mt-11;
    }
}
</style>